import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { config } from '../constants/domainConfig';
import * as vars from '../constants/constants';
import { show, hide } from '../actions/ActivityIndicatorActions';
import { getDetails, getInterests } from '../actions/AccountActions';
import { getVideosPackages, getVideos, getTVCategories, getChannels } from '../actions/CategoryActions';
import { addFavoriteChannel, addFavoriteVideo, addLikesChannels, addLikesVideos } from '../actions/FavoriteActions';
import { addVideoHistory, addChannelHistory,addShowHistory } from '../actions/HistoryActions';
import { setHeaderTitle, resetBack } from '../actions/HeaderActions';
import { console_log } from '../utils/helper';
import { sendData } from '../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Welcome extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const authorized=sessionStorage.getItem("authorized") ?JSON.parse(sessionStorage.getItem("authorized")):null
        if (authorized !==null && authorized.token != '') {
            axios.defaults.headers.common['authorization'] = authorized.token;
        }
    }

    componentDidMount() {
        sendData(this.props.access.uid, '', '', 'viewed', { url: window.location.href, page: 'welcome page' });
        this.props.setHeaderTitle('');
        axios.all([ axios.get(vars.BASE_API_URL+'/interests'), axios.get(vars.BASE_API_URL+'/categories'), axios.get(vars.BASE_API_URL+'/channels'), axios.get(vars.BASE_API_URL+'/packages'), axios.get(vars.BASE_API_URL+'/favorites'), axios.get(vars.BASE_API_URL+'/history'), axios.get(vars.BASE_API_URL+'/likes')])
            .then(axios.spread((interests, categories, channels, packages, favorites, history, likes,access) => {

                // for interests
                if (interests.data.data) {
                    this.props.getInterests(interests.data.data);
                }

                // for channel categories
                if (categories.data.data) {
                    this.props.getTVCategories(categories.data.data);
                }

                // for channels
                if (channels.data.data) {
                    this.props.getChannels(channels.data.data);
                }

                // for packages of Video On Demand
                if (packages.data.data.packages) {
                    this.props.getVideosPackages(packages.data.data.packages);

                    // for Videos On Demand
                    axios.all(packages.data.data.packages.map(l => axios.get(vars.BASE_API_URL+'/packages/'+l.id)))
                        .then(axios.spread((...res) => {
                            // all requests are now complete
                            res.map((packageDetails) => {
                                if (packageDetails) {
                                    this.props.getVideos(packageDetails.data.data.package);
                                }
                            });
                        }));
                }

                // for favorites
                if (favorites.data.data) {
                    this.props.addFavoriteChannel(favorites.data.data.channels);
                    this.props.addFavoriteVideo(favorites.data.data.videos);
                }

                // for history
                if (history.data.data) {
                    this.props.addChannelHistory(history.data.data.channels);
                    this.props.addVideoHistory(history.data.data.videos);
                    this.props.addShowHistory(history.data.data.shows);

                }

                // for likes
                if (likes.data.data) {
                    this.props.addLikesChannels(likes.data.data.channels);
                    this.props.addLikesVideos(likes.data.data.videos);
                }
            }))
            .then(()=>{
                axios.get(vars.BASE_API_URL + '/getUserProfile')
                .then(userProfile => {
                    if (userProfile.data.data) {
                        this.props.getDetails(userProfile.data.data);
                    }
                })
                .catch(err => {
                    console.log('error in fetching user profile ----------', err);
                })
            })
            .catch(err => {
                console_log(err);
            });
        window.scrollTo(0, 0);
        document.body.classList.add("welcome-page");
    }

    componentDidUpdate() {

    }

    componentWillUnmount() {
        document.body.classList.remove("welcome-page");
    }

    render() {
        return(
            <section className="welcome-page py-0">
				<section className="banner overlay-bg">
					<div className="banner__content">
						<div className="banner__content__text">
							<h1 className="banner__content__heading">
                                <FormattedMessage id="sayHello"
                                    defaultMessage="Say Hello To The Future Of Mobiletainment"
                                />
                            </h1>
						</div>
						<div className="banner__image"></div>
					</div>
				</section>
				<section className="btn-links">
                    {config.liveChannelshow ? <div className="btn__list">
                        <a className="common-btn common-btn--brown btn__list__btn" href={`/#/category/tv?uid=${this.props.access.uid}`}><span className="common-btn__text"><span className="common-btn__icon"><img className="live-btn__icon" src="./img/live.svg" alt="live" /></span>
                            <FormattedMessage id="liveChannels"
                                defaultMessage="Live Channels"
                            />
                            </span>
                        </a>
                    </div> : ''}
                    {config.movies ? <div className="btn__list">
                        <a className="common-btn common-btn--brown btn__list__btn" href={`/#/category/movies?uid=${this.props.access.uid}`}><span className="common-btn__text"><span className="common-btn__icon"><img className="live-btn__icon" src="./img/live.svg" alt="live" /></span>
                            <FormattedMessage id="movies"
                                defaultMessage="Movies"
                            />
                            </span>
                        </a>
                    </div> : ''}
					<div className="btn__list">
                        <a className="common-btn common-btn--pink btn__list__btn" href={`/#/category/vod?uid=${this.props.access.uid}`}><span className="common-btn__text"><span className="common-btn__icon"><img className="live-btn__icon live-btn__icon--vod" src="./img/vod.svg" alt="live" /></span>
                            <FormattedMessage id="vod"
                                defaultMessage="Video-on-Demand"
                            /></span>
                        </a>
					</div>
					<div className="links__list">
                        {config.movies ? null : <a className="links__list__btn" href={`/#/favorites?uid=${this.props.access.uid}`}><img src="./img/star.svg" />
                            <FormattedMessage id="favorites"
                                defaultMessage="Favorites"
                            /></a>}
                        {config.smartTVshow ? <a className="links__list__btn links__list__btn--smart" href={`/#/smartTv?uid=${this.props.access.uid}`}><img src="./img/smart-tv.svg" />
                            <FormattedMessage id="smartTV"
                                defaultMessage="Smart TV"
                            /></a>
                            : config.movies ? null : <a className="links__list__btn links__list__btn--smart" href={`/#/history?uid=${this.props.access.uid}`}><img src="./img/history.svg" />
                                <FormattedMessage id="history"
                                    defaultMessage="History"
                                /></a>}
					</div>
				</section>
            </section>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getDetails,
        getInterests,
        getVideosPackages,
        getVideos,
        getTVCategories,
        getChannels,
        addFavoriteChannel,
        addFavoriteVideo,
        setHeaderTitle,
        resetBack,
        addChannelHistory,
        addVideoHistory,
        addLikesChannels,
        addLikesVideos,
        addShowHistory
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);


// WEBPACK FOOTER //
// ./src/containers/Welcome.js